<script>
import FixedHeader from 'vue-fixed-header';

import appConfig from "@/app.config";
import GeoTargeting from "@/components/geo-targeting";

export default {
  components: {
    FixedHeader,
    GeoTargeting
  },
  page: {
    title: "Proposal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  async mounted() {
    this.apiGetPublic(`/proposals/${this.$route.params.id}/public/${this.$route.params.token}`).then((data) => {
      this.data = data;

      if (this.data) {
        this.$nextTick(()=>{
          if (this.$refs.sidebarWrapper) {
            if (window.innerWidth >= 992) {
              this.sidebarWidth = this.$refs.sidebarWrapper.offsetWidth;
            }

            window.addEventListener('resize', () => {
              if (window.innerWidth >= 992) {
                this.sidebarWidth = this.$refs.sidebarWrapper.offsetWidth;
              } else {
                this.sidebarWidth = 0;
              }
            });
          }
        })
      }
    })
  },
  data() {
    return {
      data: null,
      sidebarWidth: 0,
      googleMapsOptions: {
        zoom: 10,
        mapTypeId: "terrain",
        disableDefaultUI: true,
      },
      centerOptions: {
        fillColor: "#1591EF",
        fillOpacity: 1,
        strokeOpacity: 0
      },
      serviceOptions: {
        strokeColor: "#c71d1d",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillOpacity: 0
      }
    }
  },
  computed: {
    businessAddress() {
      const { flat, streetNumber, streetName, suburb, state, postcode } = this.data.advertiser.businessAddress

      return `${flat ? `${flat},` : ''} ${streetNumber} ${streetName}, ${suburb}, ${state} ${postcode}`;
    },
  }
}
</script>

<template>
  <div v-if="this.data">
    <div class="bg-primary">
      <div class="container d-flex justify-content-between align-items-center py-4">
        <img src="@/assets/images/logo-new.png" alt="" class="logo-sm" height="45" />
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-3 order-lg-2" ref="sidebarWrapper">
          <fixed-header :threshold="100">
            <div class="proposal__sidebar" :style="sidebarWidth ? { width: sidebarWidth + 'px' } : null">
              <div class="bg-white rounded px-3 py-4 mt-3">
                <div class="mb-5">
                  <h4 class="mb-3 h5">Advertiser Profile:</h4>
                  <div v-scroll-spy-active="{selector: 'a', class: 'active-spy'}" data-scroll-spy-id="objectivesWrapper">
                    <a href="#objectives" class="proposal__sidebar-button w-100">Marketing Objectives</a>
                  </div>
                </div>
                <div>
                  <h4 class="mb-3 h5">Campaign Options:</h4>
                  <div class="d-flex flex-column" v-scroll-spy-active="{selector: 'a', class: 'active-spy'}" data-scroll-spy-id="campaignsWrapper">
                    <a v-for="proposal in this.data.packages" :key="proposal.id" :href="`#${proposal.id}`" class="proposal__sidebar-button mb-3 text-capitalize">{{ proposal.objective }} {{ proposal.level }}</a>
                  </div>
                </div>
                <div class="border-top pt-3">
                  <div class="d-flex mb-3 align-items-center">
                    <img v-if="data.createdBy.profileImage" :src="data.createdBy.profileImage.url" class="rounded-circle proposal__agent-avatar mr-2" alt="" />
                    <div v-else class="proposal__agent-avatar align-items-center justify-content-center d-flex bg-primary mr-2 rounded-circle">
                      <i class="bx bxs-user text-white"></i>
                    </div>
                    <h4 class="flex-1 mb-0">{{ data.createdBy.firstName }} {{ data.createdBy.lastName }}</h4>
                  </div>
                  <div class="d-flex mb-3 align-items-center">
                    <div class="rounded-circle bg-soft-primary p-2 mr-2 d-flex align-items-center justify-content-center">
                      <i class="bx bxs-envelope font-size-20 text-white"></i>
                    </div>
                    <a class="text-truncate" :href="`mailto:${data.createdBy.email}?subject=${data.name} - Campaign Proposal by ACM Advantage`">{{ data.createdBy.email }}</a>
                  </div>
                  <div class="d-flex align-items-center" v-if="data.createdBy.phoneNumber">
                    <div class="rounded-circle bg-soft-primary p-2 mr-2 d-flex align-items-center justify-content-center">
                      <i class="bx bxs-phone font-size-20 text-white"></i>
                    </div>
                    <a :href="`tel:${data.createdBy.phoneNumber}`">{{ data.createdBy.phoneNumber }}</a>
                  </div>
                </div>
              </div>
            </div>
          </fixed-header>
        </div>
        <div class="col-12 col-lg-9 order-lg-1">
          <div v-scroll-spy="{ allowNoActive: true }" data-scroll-spy-id="objectivesWrapper">
            <div id="objectives">
              <div class="bg-white rounded p-3 my-3 proposal__advertiser-logo-wrapper">
                <img v-if="data.advertiser.logoImage" :src="data.advertiser.logoImage.url" class="proposal__advertiser-logo" :alt="`${data.advertiser.businessName} logo`" />
                <div class="">
                  <h4>{{ data.advertiser.businessName }}</h4>
                  <p class="mb-0">{{ businessAddress }}</p>
                </div>
              </div>
              <div class="bg-white rounded p-4">
                <h5 class="mb-4">Category: {{ data.advertiser.businessType.name }}</h5>
                <div class="row">
                  <div class="col-12 col-xl-8">
                    <h5>Marketing Description:</h5>
                    <p>{{ data.advertiser.servicesDescription }}</p>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="d-flex flex-column justify-content-center bg-soft-primary rounded p-2 text-center mb-3">
                      <p>Primary Audience</p>
                      <h5>
                        <span class="text-capitalize">{{ data.advertiser.customerPrimaryGender }}</span> {{ data.advertiser.customerPrimaryAgeRanges.join(', ') }}
                      </h5>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4" v-if="data.advertiser.customerSecondaryGender">
                    <div class="d-flex flex-column justify-content-center bg-soft-primary rounded p-2 text-center mb-3">
                      <p>Secondary Audience</p>
                      <h5><span class="text-capitalize">{{ data.advertiser.customerSecondaryGender }}</span> {{ data.advertiser.customerSecondaryAgeRanges.join(', ') }}</h5>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="d-flex flex-column justify-content-center bg-soft-primary rounded p-2 text-center mb-3">
                      <p>Service Reach</p>
                      <h5>{{ data.advertiser.servicesPostcode }} +{{ data.advertiser.servicesRadius }}km</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="proposal__google-maps-wrapper mt-3 mb-5" v-if="data.advertiser.servicesCoordinates.lat && data.advertiser.servicesCoordinates.lng">
                <gmap-map :center="data.advertiser.servicesCoordinates" :options="googleMapsOptions" class="h-100">
                  <gmap-circle :center="data.advertiser.servicesCoordinates" :radius="600" :options="centerOptions"></gmap-circle>
                  <gmap-circle :radius="data.advertiser.servicesRadius * 1000" :center="data.advertiser.servicesCoordinates" :options="serviceOptions"></gmap-circle>
                </gmap-map>
              </div>
            </div>
          </div>
          <div>
            <div class="border-bottom mb-3">
              <h1 class="mb-3">Campaign Options</h1>
            </div>
            <div v-scroll-spy="{ allowNoActive: true }" data-scroll-spy-id="campaignsWrapper">
              <div class="bg-white rounded mb-5" v-for="packageObject in this.data.packages" :key="packageObject.id" :id="packageObject.id">
                <div class="p-3">
                  <div class="row justify-content-between align-items-center mb-3">
                    <div class="col-12 col-md-6 order-md-2 d-flex justify-content-end">
                      <img v-if="packageObject.masthead && packageObject.masthead.logoImage" :src="packageObject.masthead.logoImage.url" alt="masthead logo image" class="proposal__masthead-logo" />
                      <h4 v-else>{{ packageObject.masthead.name }}</h4>
                    </div>
                    <div class="col-12 col-md-6 order-md-1">
                      <h2 class="mb-0 text-capitalize">{{ packageObject.objective }} {{ packageObject.level }}</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                        <p>Print</p>
                        <h5 class="mb-0">{{ packageObject.totalImpacts | formatNumberWithCommas }} Impacts</h5>
                      </div>
                    </div>
                    <div v-if="packageObject" class="col-12 col-md-6 col-lg-4">
                      <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                        <p>Digital</p>
                        <h5 class="mb-0">{{ packageObject.impressions | formatNumberWithCommas }} Impressions</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                        <p>Investment (inc GST)</p>
                        <h5 class="mb-0">{{ packageObject.priceIncludingGst | formatCurrency }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="packageObject.masthead && packageObject.masthead.coordinates.lat && packageObject.masthead.coordinates.lng" class="proposal__google-maps-wrapper">
                  <geo-targeting
                    :location="packageObject.masthead.coordinates"
                    :printRadius="packageObject.masthead.printRadius * 1000"
                    :digitalRadius="packageObject.masthead.digitalRadius * 1000"
                  />
                </div>
                <div class="p-3">
                  <div class="mb-3" v-if="packageObject.type === 'Print & digital'">
                    <h3 class="mb-3 h4">Print Insertions</h3>
                    <div class="row">
                      <div class="col-12 col-md-6 col-lg-4">
                        <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                          <p>Insertions</p>
                          <h5 class="mb-0">{{ packageObject.totalInsertions }}</h5>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg-4">
                        <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                          <p>Size</p>
                          <h5 class="mb-0">{{ packageObject.printSize }}</h5>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg-4">
                        <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                          <p>Section</p>
                          <h5 class="mb-0">{{ packageObject.earlyGeneralNews }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3" v-if="packageObject.digitalChannels">
                    <h3 class="mb-3 h4">Digital Channels</h3>
                    <div class="row">
                      <div class="col-12 col-md-6 col-lg-4" v-for="digitalChannel in packageObject.digitalChannels" :key="digitalChannel">
                        <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                          <h5 class="mb-0 text-capitalize">{{ digitalChannel }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <div class="mb-3" v-if="packageObject.digitalChannels.includes('Display')">
                        <h5>IAB Std Digital Display </h5>
                        <ul class="list-none">
                          <li>300x600</li>
                          <li>160x600</li>
                          <li>300x250</li>
                          <li>970x250</li>
                        </ul>
                      </div>
                      <div class="mb-3" v-if="packageObject.digitalChannels.includes('Social')">
                        <h5>Social</h5>
                        <ul class="list-none">
                          <li>Desktop: Newsfeed, Marketplace, Articles</li>
                          <li>Mobile: Newsfeed, Marketplace, Stories</li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="mb-3" v-if="packageObject.digitalChannels.includes('Native')">
                        <h5>Native</h5>
                        <ul class="list-none">
                          <li>Desktop Newsfeeds</li>
                          <li>Desktop Publishers</li>
                          <li>Mobile Newsfeeds</li>
                          <li>Native Apps</li>
                        </ul>
                      </div>
                      <div class="mb-3" v-if="packageObject.digitalChannels.includes('Search')">
                        <h5>Search</h5>
                        <ul class="list-none">
                          <li>Brand and Location</li>
                          <li>Category Description Keywords</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-dark mt-5 py-5">
      <div class="container text-center">
        <img src="@/assets/images/logo-new.png" alt="" class="logo-sm mb-4" height="70" />
        <p class="text-white mb-0 w-75 m-auto text-left text-md-center">
          Bookings are accepted for publication subject to Australian Community Media's Terms and Conditions, which can be viewed <a href="https://www.acmadcentre.com.au/terms-conditions/" rel="noopener" target="_blank">here</a>. All information about advertising rates, volumes and prices is confidential information. Advertisers must not disclose, publish or disseminate confidential information to any third party.
        </p>
      </div>
    </div>
  </div>
</template>
